import { useQuery } from "graphql-hooks";
import { Hero } from "../Shared/Hero";
import { Loading } from '../Shared/Loading';
import { ErrorPage } from "../Shared/ErrorPage";
import { NavigationCardSet } from '../Shared/NavigationCards/NavigationCardSet';
import { ContentBlock } from "../Shared/Content/ContentBlock";
import { ContentBody } from "../Shared/Content/ContentBody";
import { useAPIErrorContext } from '../../contexts/apiErrorContext';

const CMS_QUERY = `query datoQuery {
    pageData: pageContactConfirmation {
        fieldHeroTitle
        fieldBodyContent1
        fieldCardNavigationSectionTitle
        fieldNavigationCards {
            id
            fieldCardTitle
            fieldCardLink
            fieldCardContent
            fieldCardImage {
                alt
                url
                title
            }
        }
    }
}`;

export const Confirmation = () => {
    const { loading, error, data } = useQuery(CMS_QUERY);
    const { trackError } = useAPIErrorContext();

    if (!error && !loading) {
        return (
            <div className="contactUsPage">
                <Hero pageTitle={data.pageData.fieldHeroTitle} />
                <ContentBlock className="contactUsConfirmation">
                    <ContentBody>
                            <div className="sectionPadding">
                                <div className="contactUsConfirmationBody" dangerouslySetInnerHTML={{ __html: data.pageData.fieldBodyContent1 }} />
                            </div>
                    </ContentBody>
                </ContentBlock>
                {/* include "More About Program" tri-cards */}
                <NavigationCardSet PageData={data.pageData} />
            </div>
        );
    }
    else if (!error) {
        return (<Loading showContent={true} includeHero={true} />);
    }
    else {
        trackError("Dato error", JSON.stringify(error));
        return (<ErrorPage showContactForm={false} includeHero={true} />);
    }
};
